import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import AddContactPage from './pages/AddContactPage';
import AddEmailPage from './pages/AddEmailPage';
import AddMeetingPage from './pages/AddMeetingPage';
import EditAttendeesPage from './pages/EditAttendeesPage';
import EditRecipientsPage from './pages/EditRecipientsPage';
import UpdateContactPage from './pages/UpdateContactPage';
import AddNewRecordFromContactPage from './pages/AddNewRecordFromContactPage';
import SummaryPage from './pages/SummaryPage';
import AddAffiliationPage from './pages/AddAffiliationPage';
import AdminPage from './pages/AdminPage';
import FileExplorer from './pages/FileExplorer';
import config from './config/config';
import './App.css';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, inProgress } = useMsal();
  const [isLoaded, setIsLoaded] = useState(false);

  // make this interval only run once after the initial render via useEffect(func(), [])
  // the return of the function inside of useEffect is what to do on clean up or unmount
  // but don't allow it to keep making refresh API requests after a user logs out
  useEffect(() => {
    async function getAPIToken(email) {
      await fetch(config.apiURL + '/signin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
        .then((res) => {
          if (res?.status >= 400) {
            throw new Error('Error logging in');
          }
          return res.json();
        })
        .then((result) => {
          config.saveToken(result);
        })
        .catch((error) => {
          console.error(error);
        });
      setIsLoaded(true);
    }

    if (
      isAuthenticated &&
      inProgress === 'none' &&
      accounts.length > 0 &&
      !isLoaded
    ) {
      const email = accounts[0] && accounts[0].username;
      getAPIToken(email.toLowerCase());
    }
    var interval = setInterval(async function refreshToken() {
      if (
        config.getToken() !== '' &&
        isAuthenticated &&
        config.validateToken()
      ) {
        await fetch(config.apiURL + '/refresh', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token: config.getToken()
          }
        })
          .then((data) => data.json())
          .then((response) => config.saveToken(response))
          .catch((error) => {
            console.error(error.message);
            config.saveToken('');
            clearInterval(interval);
          });
      }
      return () => {
        clearInterval(interval);
      };
    }, 1000 * 60 * 15);
  }, [accounts, inProgress, isAuthenticated, isLoaded]);

  if (isLoaded && isAuthenticated && config.getToken !== '') {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={LoginPage} />
          <Route exact path='/home' component={LandingPage} />
          <Route
            exact
            path='/summary/:selectName/:contact_id/:poc_id'
            component={SummaryPage}
          />
          <Route exact path='/fileExplorer' component={FileExplorer} />
          {config.decodeJWT().admin && (
            <Switch>
              <Route exact path='/admin' component={AdminPage} />
              <Route exact path='/addEmail' component={AddEmailPage} />
              <Route exact path='/addMeeting' component={AddMeetingPage} />
              <Route
                exact
                path='/addAffiliation'
                component={AddAffiliationPage}
              />
              <Route exact path='/addContact' component={AddContactPage} />
              <Route
                exact
                path='/editRecipients/:email_subject/:date_time/:email_id'
                component={EditRecipientsPage}
              />
              <Route
                exact
                path='/editAttendees/:meeting_name/:date_time/:meeting_id'
                component={EditAttendeesPage}
              />
              <Route
                exact
                path='/updateContact/:affiliation_id/:contact_id/:poc_id'
                component={UpdateContactPage}
              />
              <Route
                exact
                path='/addNewRecord/:affiliation_id/:contact_id/:poc_id'
                component={AddNewRecordFromContactPage}
              />
            </Switch>
          )}
        </Switch>
      </BrowserRouter>
    );
  } else if (!isLoaded && isAuthenticated) {
    return (
      <center>
        <div>Loading... Please Wait.</div>
      </center>
    );
  } else if (!isLoaded && !isAuthenticated && inProgress !== 'none') {
    return (
      <center>
        <div>Loading... Please Wait.</div>
      </center>
    );
  } else {
    return <LoginPage />;
  }
}

export default App;
